export default "__VITE_ASSET__e0255b39__"